/**
 *
 * @param {Object} opts
 * @param {Object} opts.mockError
 * @param {Object} opts.mockResponse
 * @param {Object} opts.mockDelay - request timing
 * @returns {Object}
 */
const mockRequest = (opts): Promise<any> => (
  new Promise((resolve, reject) => {
    setTimeout(() => {
      if (opts.mockError) {
        reject(opts.mockError)
      }
      else {
        const { data, body, ...rest } = opts.mockResponse || {}

        resolve({
          data: data || body,
          status: 200,
          ...rest,
        })
      }
    }, opts.mockDelay || 500)
  })
)


export default mockRequest
